const COMPANY_DEFAULT_LOGO = {
  en: 'https://assets.olaclick.app/assets/logos/v2/logo-en.jpg',
  es: 'https://assets.olaclick.app/assets/logos/v2/logo-es.jpg',
  fr: 'https://assets.olaclick.app/assets/logos/v2/logo-fr.jpg',
  pt: 'https://assets.olaclick.app/assets/logos/v2/logo-pt.jpg',
  default: 'https://assets.olaclick.app/assets/logos/v2/logo-en.jpg'
}

const getDefaultCompanyLogo = (company) => {
  const language = company?.language || 'en'

  return COMPANY_DEFAULT_LOGO[language] || COMPANY_DEFAULT_LOGO.default
}

export default getDefaultCompanyLogo
